export default {
  locale: "en",
  name: "Configuration manager",
  translation: { displayName: "Translations" },
  fields: {
    list: [],
    form: [
      {
        fieldName: "useCustomEmailTemplate",
        displayName: "Use custom templates",
        description: "Activate this to allow the user to create their own templates",
        helpText: "If no template is created and active the default template will be used",
      },
      {
        fieldName: "pedircodigoseguridad",
        displayName: "Activate CCV field for PCIProxy",
        description: "Activates the CCV Field for the PCIProxy payment type",
        helpText:
          "Currently only works for PCI Proxy, could be expanded to other payment types in the future",
      },
      {
        fieldName: "activeAbandonmentCart",
        displayName: "Activer l'e-mail d'abandon de panier - FIDÉLITÉ",
        description: "Activer l'e-mail d'abandon de panier - FIDÉLITÉ",
        helpText: "FIDÉLITÉ lors de la connexion",
      },
      {
        fieldName: "activeAbandonmentCartNotLoyalty",
        displayName: "Activer l'e-mail d'abandon de panier - SANS FIDÉLITÉ",
        description: "Activer l'e-mail d'abandon de panier - SANS FIDÉLITÉ",
        helpText: "AUCUNE FIDÉLITÉ lors de la saisie de l'adresse e-mail du client",
      },
      {
        fieldName: "useWebcampIntegration",
        description: "Utiliser l'intégration Webcamp",
        helpText: "Si actif, Webcamp sera utilisé pour la gestion des disponibilités",
      },
      {
        fieldName: "keepMultiConfigOnRedirect",
        description: "Conserver l'apparence lors du changement de moteur",
      },
      {
        fieldName: "preventRestrictiveRateCombinations",
        description: "Toujours appliquer le tarif le plus restrictif",
      },
      {
        fieldName: "extrasCategoriesActive",
        description: "Activer les extras avec catégories",
        helpText:
          "Active sur cet établissement les catégories d'extras (Véhicule, Installations) : limites et quantités incluses par type d'hébergement, facturation uniquement de ce qui dépasse l'inclus et plaque d'immatriculation par véhicule. Une fois désactivé, les extras se vendent comme d'habitude ; ce qui a été configuré est conservé et s'applique de nouveau à la réactivation.",
      },
    ],
  },
};
